export const en = {

    // Login
    loginTitle: 'Welcome',
    loginMessage: 'Enter your Login',
    username: 'Username',
    email: 'Email',
    password: 'Password',
    newPassword: 'New Password',
    repeatNewPassword: 'Repeat New Password',
    authenticateUser: 'Authenticate User',
    recoverPassword: 'Recover Password',
    recoverPasswordDescription: 'Check your Email and Follow Instructions to Reset your Password',
    forgotPassword: 'Forgot Password',
    code: 'Code',
    acceptWordOs: 'Accept',
    acceptWordAs: 'Accept',
    termsConditions: 'Terms & Conditions',
    cookies: 'Cookies Policy',
    privacyRule: 'Accept',
    privacyRuleLink: 'Data Confidentiality',
    repeatPasswordLabel: 'Repeat the Password used above',
    inputLabelNewPassword: 'Password must Respect the Requirements',
    logout: 'Logout',


    //---- Nav Bar Items-----
    inicio: 'Home',
    municipality: 'Municipality',
    territory: 'Territory',
    autarchy: 'Autarchy',
    entity: 'Entity',
    emissions: 'Emissions of GEE in Territory',

    map: 'Map',
    emissionsDistribution: 'Emissions of GEE in the Territory',
    energyConsumption: 'Energy Consumption',
    flowchartEmissions: 'Emissions Flowchart',
    generalIndicators: 'General indicators',

    politicas: 'Policies',
    events: 'Events',
    registry: 'Registry',
    registrationManagement: 'Registration Management',
    searchForAsset: 'Search by Asset',
    searhForResource: 'Search by Asset Code',
    energy: 'Energy',
    analytics: 'Analytics',
    timeLine: 'Timeline',
    filters: 'Filters',
    energyEmissions:'Energy and Emissions',
    //---------
    contractsOfElectricitity: 'Electricity Contracts',
    electricityConsumptionByType: 'Electricity Consumption by Tipology',
    gasContracts: 'Gas Contracts',
    buildingsEvaluated: 'Buildings Under Monitoring',
    installationsByVoltageLevel: 'Installation by Voltage Level',

    anualGasConsumption: 'Annual Gas Consumption',
    accumulatedTooltip: 'Acumulated value for the selected period',
    anualElectricityConsumption: 'Annual Electricity Consumption',
    anualElectricityConsumptionTotal: 'Annual Electricity Total Consumption',
    anualElectricityConsumptionMtAtMat: 'Annual Electricity Consumption (MT+AT+MAT)',
    anualElectricityConsumptionBtnBte: 'Annual Electricity Consumption (BTN+BTE)',
    anualCO2Emissions: 'Annual GEE Emissions',

    topConsumers: 'Highest Consumption Facilities',
    monthlyElectricityConsumption: 'Monthly Eletricity Consumption',
    sectorCO2Emissions: 'Emissions by Sector',
    sectorEnergyConsumption: 'Energy Consumption per sector',
    cO2EmissionsEvolution: 'Emissions Evolution by Sector',
    emissionsScope: 'Emissions by Scope',
    evolutionEmissionsScope: 'Emissions Evolution by Scope',
    evolutionBySector: 'Evolution of Emissions by Sector',

    totalEnergyConsumption: 'Evolution of Total Energy Consumption',
    electricityConsumption: 'Electricity Consumption',
    gasConsumption: 'Gas Consumption',

    diagramSankey: 'Sankey Diagram (tCO2eq)',
    loadDiagrams: 'Load Diagrams',

    "Events Severity": 'Events by Severity',
    critical: 'Critical',
    high: 'High',
    medium: 'Medium',
    low: 'Low',
    others: 'Others',
    eventsMap: 'Events Map',
    eventDensity: 'Event Density',
    seeInfoEvents: 'See Info Events',
    territoryConsumptionDensity: 'Territory Consumption Density',
    "Show info": "Show info",
    "Severity": "Severity",
    "Open Date": "Open Date",
    "Class": "Class",
    "Name": "Name",
    "Description": "Description",
    "Category": "Category",

    exportToPdf: 'Export to PDF',
    exportsToCsv: 'Export to CSV',

    totalPowerInstalledQuarterConsumption: 'Total Power Installed per Quarter for Self-consumption',
    totalPowerInstalledDescription: 'Total Cumulative Installed Power per Quarter - Total Municipal',

    usersList: 'Users List',
    activePotency: 'Active Potency',
    reactiveIndutivePotency: 'Reactive Indutive Potency',
    reactiveCapacitivePotency: 'Reactive Capacity Potency',
    productionPotency: 'Prodution Potency',
    annualExportUnavailable: 'It is not possible to export data for annual period',
    dataExportionForPeriod: 'Exportation for the selected period ',
    totalEmissions: 'Total Emissions',
    resultingEnergyConsumption: 'Resulting Energy Consumption',
    carbonCapture: 'Carbon Capture',

    //Daily analisis
    activeEnergyAndProduction: 'Active Energy and Production Energy',
    indutiveAndCapacitiveEnergy: 'Inductive Energy and Capacitive Energy',
    topEnergy:'Active Potency Peak',
    inductiveConsumption: 'Inductive Energy Consumption',
    energyProduced: 'Energy Produced',
    activeConsumption: 'Active Energy Consumption',
    capacitiveConsumption: 'Capacitive Energy Consumption',
    gridInjection: 'Injection in the Grid',
    informationFromPreviousPeriod: 'Information of the previous 31 days',
    activePower: 'Active Power',
    productionPower: 'Production Power',
    inductivePower: 'Inductive Power',
    capacitivePower: 'Capacitive Power',
    highestRegistedPeak: 'Highest Registered Peak',
    inductiveConsumption: 'Inductive Energy Consumption',
    activeConsumption: 'Active Energy Consumption',
    capacitiveConsumption: 'Capacitive Energy Consumption',
    dailyPowerPeaks: 'Daily Power Peaks',
    productionPeak: 'Production Peak',
    loadDiagrams: 'Daily Load Diagram',
    'Daily Analysis': 'Daily Analysis',
    Historical: 'Historical',

    //----- Buttons --------
    seeOnMap: 'See on Map',
    delete: 'Delete',
    add: 'Add',
    apply: 'Apply',
    clear: 'Clear',
    lines: 'Lines',
    bars: 'Bars',
    heatmap: 'HeatMap',
    report: 'Report',
    exportRawData: 'Export Raw Data',
    signIn: 'Sign In',
    resetPassword: 'Reset Password',
    sendEmail: 'Send Email',
    edit: 'Edit',
    submit: 'Submit',
    cancel: 'Cancel',
    save: 'Save',
    seeDetail: 'See Detail',
    upload: 'Upload',
    deleteDescription: 'Are you sure you want to delete the item?',
    //-------------------------------
    Energy: 'Energy',
    inductive: 'Inductive',
    capacitive: 'Capacitive',
    activeEnergy: 'Active Energy',
    energyProduced: 'Energy Produced',
    inductiveEnergy: 'Inductive Energy',
    capacitiveEnergy: 'Capacitive Energy',
    reactiveEnergy: 'Reactive Energy',
    powerCharges: 'Power Charges',
    inductiveReactiveEnergy: 'Inductive Reactive Energy',
    capacitiveReactiveEnergy: 'Capacitive Reactive Energy',
    activeEnergyConsumption: 'Active Energy Consumption',
    inductiveEnergyConsumption: 'Inductive Energy Consumption',
    capacitiveEnergyConsumption: 'Capacitive Energy Consumption',
    selfConsumption: 'of Self-consumption',
    emissionsAvoided: 'Accumulated Emissions Avoided',
    averageConsumption: 'Average Consumption',
    maximumConsumption: 'Maximum Consumption',
    averageConsumptionDaysOfWeek: 'Average Consumption days of the week',
    daysOfWeek: 'Days of the week',
    pickPower: 'Pick Power',
    averagePower: 'Average Power',
    saturdayAndSunday: 'Saturdays and Sundays',
    consumption: 'Consumption',
    fourHourly: 'Four-Hourly',
    empty: 'Empty',
    full: 'Full',
    edge: 'Edge',
    superEmpty: 'Super Empty',
    providedByTheGrid: 'Provided by the grid',
    injectedIntoTheGrip: 'Injected into the grid',
    fixedTariffTerm: 'Fixed Tariff Term',
    contractedPower: 'Contracted Power',
    powerPeakHours: 'Power at Peak Hours',
    finalCost: 'Final Cost',
    associatedCO2Emissions: 'Associated GEE Emissions',
    imagesForReport: 'Images for Report',
    powerChanges: 'Power Changes',
    peakHours: 'Peak Hours',
    noDataResource: 'No Resouces Available',
    noData: 'No data',
    //------------
    search: 'Search',
    selectPeriod: 'Select Period',
    eletricEnergy: 'Eletric Energy',
    production: 'Production',
    export: 'Export',
    energeticCertification: 'Energetic Certification',
    relatedAssets: 'Related Assets',
    costEstimation: 'Cost Estimation',
    selectPotency: 'Select Potency',
    searchByCPE: 'Search By CPE',
    energyVector: 'Energy Vector',
    //------ Date Formats -----
    day: 'day',
    days: 'Days',
    week: 'Week',
    weeks: 'Weeks',
    months: 'Months',
    year: 'Year',
    years: 'Years',
    hourly: 'Hourly',
    daily: 'Daily',
    weekly: 'Weekly',
    startDate: 'Start date',
    endDate: 'End date',
    annual: 'Annual',
    monthly: 'Monthly',
    quarter: 'Quarter',
    yearly: 'Yearly',
    raw: 'Raw',

    jan: 'jan',
    feb: 'feb',
    mar: 'mar',
    apr: 'apr',
    may: 'may',
    jun: 'jun',
    jul: 'jul',
    aug: 'aug',
    sep: 'sep',
    oct: 'oct',
    nov: 'nov',
    dec: 'dec',

    mon: 'mon',
    tue: 'tue',
    wed: 'wed',
    thu: 'thu',
    fri: 'fri',
    sat: 'sat',
    sun: 'sun',
    //------------
    data: 'Data',
    name: 'Name',

    simple: 'Simple',
    biHourly: 'Bi-hourly',
    triHourly: 'Tri-hourly',
    tetraHourly: 'Tetra-hourly',

    page: 'Page',
    seeMore: 'See More',
    seeLess: 'See Less',

    simulatedTariffs: 'Simulated Tariffs',
    //------------ Tooltips -----------
    passwordRequirements: 'Password Requirements',
    minimunCharacters: '8 minimun characters',
    numberCharacter: 'Contains at least 1 number',
    uppercaseLetter: 'Contains at least 1 uppercase letter',
    lowercaseLetter: 'Contains at least 1 lowercase letter',
    specialCharacter: 'Contains at least 1 special character',
    dataBasedEReded: 'Generated based on the latest E-REDES Open Data data',
    dataRefersToYear: 'Data refers to the year of ',
    comparingElectricityConsumption:'Comparing Electricity Consumption',
    heatmapExplained:'Heatmap generated using  the Distribution Transformer Stations consumption of the Territory',
    heatmapTooltip:'Heatmap showing the electricity consumption density of the territory',
    "BTN: Low Normal Voltage":"BTN: Low Normal Voltage",
    "BTN-IP: Low Normal Voltage in Public Lighting":"BTN-IP: Low Normal Voltage in Public Lighting",
    "BTE: Special Low Voltage":"BTE: Special Low Voltage",
    "MT: Medium Voltage":"MT: Medium Voltage",
    "AT: High Voltage":"AT: High Voltage",

    //------------ AuthContext Errors -----------
    incorrectFields: 'Incorrect Username or Password',
    passwordNoMatch: 'Passwords don´t match',
    passwordNotValid: 'Password doesn´t match the requirements',
    emailSentCode: 'Email sent with the verification code',
    codeSentByMessage: 'Code sent by message',
    firstLogin: 'First login, user needs to authenticate',
    errorResetPassword: 'Something went wrong, please check the code or password requirements',
    infoDescription: 'Can´t export when there are no data available',

    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Information',

    successAdd: 'Items added with success.',
    errorAdd: 'Error: item not added.',

    successDelete: 'Items deleted with success.',
    errorDelete: 'Error: item not deleted.',

    errorGettingCertificates: 'An error occurred getting certificate list.',
    //--------------------- Forms -----------------
    phoneNumber: 'Phone Number',
    expirationDate: 'Expiration Date',
    energyClass: 'Energy Class',

    //--------------------- Tooltip ----------------------
    contractsOfElectricitityTooltip: 'Total assets (including Street Lighting) with electricity data registered',
    gasContractsTooltip: 'Total assets with gas data registered',
    buildingsEvaluatedTooltip: 'Total assets of type “Building” with data registered',
    IPPUTooltip: 'IPPU: Industrial Processes and product use',
    AFOLUTooltip: 'AFOLU: Agriculture, forestry and other land use',
    mapOverlayTooltip: 'Consumption acumuated value',
    searchResourceTooltip: 'Search by CPE, CUI or String Inverter',
    estimatedValue: 'Estimated value, representing the territory’s capacity to absorb Carbon',

    //--------------------- Filters -----------------
    filters: 'Filters',
    rester: 'Reset',
    savedFilters: 'Saved Filters',
    apply: 'Apply',

    Buildings: 'Buildings',
    Infrastructures: 'Infrastructures',

    //Edifícios
    Others: 'Others',
    Social: 'Social',
    'Social Housing': 'Social Housing',
    'Sports': 'Sports',
    'Administrative': 'Administrative',
    'Civil Protection': 'Civil Protection',
    'Cultural Spaces': 'Cultural Spaces',
    'School': 'School',
    Health: 'Health',
    Storage: 'Storage',
    'Pavilion': 'Pavilion',

    //Infraestruturas
    'Parking Lot': 'Parking Lot',
    'Street Lighting': 'Street Lighting',
    'Domestic Waste Collection': 'Domestic Waste Collection',
    'Sanitary waste water collection': 'Sanitary waste water collection',
    'Tunnel': 'Tunnel',
    'Graveyard': 'Graveyard',
    'Water Supply': 'Water Supply',
    'Electric Vehicle Charging Station': 'Electric Vehicle Charging Station',
    'Road Segment': 'Road Segment',
    'Energy Production': 'Energy Production',
    'Distribution Network': 'Distribution Network',
    'Advertising Panels': 'Advertising Panels',
    'Traffic Light': 'Traffic Light',

    'Public Space': 'Public Space',
    'Commercial': 'Commercial',
    'Monument': 'Monument',

    //New Analytics Page
    'GEE Emissions':'GEE Emissions',
    'Number of Installations':'Number of Installations',
    'Total Consumption':'Total Consumption',
    'Cumulative analysis':'Cumulative analysis',
    'Comparative analysis':'Comparative analysis',
    "Select periodicity":"Select periodicity",
    "Select Metric/s":"Select Metric/s",
    "Active Energy":"Active Energy",
    "Inductive Reactive Power":"Inductive Reactive Power",
    "Capacitive Reactive Power":"Capacitive Reactive Power",
    "Production":"Production",
    'Active Power':'Active Power',
    'Reactive Inductive Power': 'Reactive Inductive Power',
    'Reactive Capacitive Power': 'Reactive Capacitive Power',
    "Gas":"Gas",
    'Cumulative Analysis':'Cumulative Analysis',
    "Energy Certificate":"Energy Certificate",
    "GaS":"Gas",
    "Energy Production":"Energy Production",
    "Limit of 5 items":"Limit of 5 items",
    "Total Accumulated":"Total Accumulated",
    "Typology":"Typology",
    "Address":"Address",
    "Voltage Level":"Voltage Level",
    "Contracted Power":"Contracted Power",
    "Municipality-Parish": "Municipality-Parish",
    "Max Allowed Power":"Max Allowed Power",
    "Entity/Subentity":"Entity/Subentity",
    "Daily Average":"Daily Average",
    "Daily Peak":"Daily Peak",
    "Production Power":"Production Power",
    "Inductive Power":"Inductive Power",
    "Capacitive Power":"Capacitive Power",
    "Consumed":"Consumed",
    "Produced":"Produced",
    "Event List":"Event List",
    'Limit of 5 items':'Limit of 5 items',
    "Distribution Transformer Stations":"Distribution Transformer Stations",
    "Facilities":"Facilities",
    "Top Consumers":"Top Consumers",
    "Invalid POI position":"Invalid POI position",
    "The density map takes into account the longevity of the event": "The density map takes into account the longevity of the event",
};